import Util from '@/lib/util'
export default [
    {
        title:Util.L('Order'),
        key:'orderNo',
        width: 80,
      },
    {
        title:Util.L('Code'),
        key:'code'
    },
    {
        title:Util.L('Type'),
        width: 170,
        key:'binTypeName'
    },
    {
        title:Util.L('Room'),
        width: 150,
        key:'roomCode'
    },
    {
        title:Util.L('Aisle'),
        width: 150,
        key:'aisleCode'
    },
    {
        title:Util.L('Level'),
        width: 150,
        key:'level',
        align: "right",
        render: (h:any,params:any) =>{
            return h('span', Util.toViewNumberString(params.row.level));
        }
    },
    // {
    //     title:Util.L('CreationTime'),
    //     key:'lastModificationTime',
    //     render:(h:any,params:any)=>{
    //         return h("span", Util.toViewDateString(params.row.lastModificationTime));
    //     }
    // },
    {
        title: Util.L('Action'),
        slot: 'action',
        align: 'center',
        fixed:'right',
        width: 100
    }]